import { TJsonQueryKeys, TJsonQueryOptionalKeys } from '../../../packages/JsonQuery';

export const MAX_VISIBLE_FILTERS = 7;
export const COMMON_FILTERS: TJsonQueryKeys[] = [
  '_type',
  'for_day',
  'dates',
  'region',
  'geo',
  'engine_version',
  'price',
  'room',
  'online_booking',
  'kids',
  'pets',
  'is_by_homeowner',
  'zalog',
  'beds_count',
  'page',
  'bbox',
  'sort',
];

// Поля, которые не сбрасываются при сбросе всех фильтров
export const NON_RESETTABLE_FILTERS = ['_type', 'for_day', 'dates', 'region', 'engine_version', 'geo', 'beds_count'];

// Служебные ключи jsonQuery: присутствуют всегда (пагинация/область карты/сортировка) и не считаются пользовательскими фильтрами
export const SERVICE_FILTER_KEYS: TJsonQueryOptionalKeys[] = ['page', 'bbox', 'sort'];
